import api from './api';

export const mfaService = {
  /**
   * Get current MFA status
   */
  getStatus: async () => {
    const response = await api.get('/mfa/status');
    return response.data;
  },

  /**
   * Begin MFA setup - get QR code and secret
   */
  beginSetup: async () => {
    const response = await api.post('/mfa/setup');
    return response.data;
  },

  /**
   * Verify setup code and enable MFA
   */
  verifySetup: async (secret, code) => {
    const response = await api.post('/mfa/verify-setup', { secret, code });
    return response.data;
  },

  /**
   * Disable MFA
   */
  disable: async (password, code) => {
    const response = await api.post('/mfa/disable', { password, code });
    return response.data;
  },

  /**
   * Regenerate recovery codes
   */
  regenerateRecoveryCodes: async (password) => {
    const response = await api.post('/mfa/regenerate-recovery-codes', { password });
    return response.data;
  },

  /**
   * Verify MFA code during login (called from auth service)
   */
  verifyLogin: async (mfaToken, code, isRecoveryCode = false) => {
    const response = await api.post('/auth/verify-mfa', { 
      mfaToken, 
      code, 
      isRecoveryCode 
    });
    return response.data;
  }
};

export default mfaService;